export default "__VITE_ASSET__BsDFabIO__"